import { ReactElement } from "react";
import { getPalette } from "../../configuration/configuration";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import RemoveIcon from "@mui/icons-material/Remove";

interface IIndicator {
  status?: boolean;
  direction: "UP" | "DOWN" | "UNDEFINED";
}

interface IKeyValueProps {
  name: string;
  value: number | string;
  unit?: string;
  indicator?: IIndicator;
}

const KeyValueItem = ({ name, value, unit, indicator }: IKeyValueProps): ReactElement => {

  let background = getPalette().statusColor.gray.background;
  if (indicator && indicator.status !== undefined) {
    background = indicator.status ? getPalette().statusColor.good.background : getPalette().statusColor.error.background;
  }

  return (
    <div className="display-flex-row justify-content-space-between w-100">
      <strong>
        {name}
        {unit && <sub>{` [${unit}]`}</sub>}
      </strong>
      <strong>{value}</strong>
      {indicator &&
      <div className="display-flex-row flex-grow-0 ml-1 justify-content-center align-items-center">
        { indicator.direction === "UP" && <ArrowUpwardIcon style={{ color: "whitesmoke", background, verticalAlign: "center" }} fontSize="small"/> }
        { indicator.direction === "DOWN" && <ArrowDownwardIcon style={{ color: "whitesmoke", background, verticalAlign: "center" }} fontSize="small"/> }
        { indicator.direction === "UNDEFINED" && <RemoveIcon style={{ color: "whitesmoke", background, verticalAlign: "center" }} fontSize="small"/> }
      </div>
      }
    </div>);
};


export default KeyValueItem;
